export enum PATHS {
  HOME = "/",
  LOGIN = "/login",
  UPLOAD = "/upload",
  GENERATE_RECALL_TOKENS = "/tokens",
  USERS = "/users",
  DASHBOARD = "/dashboard"
}
